import { toast, ToastOptions, TypeOptions } from 'react-toastify'

import Icon from '../Icon'

type AlertProps = {
  data: {
    type: TypeOptions
    text: string
  }
  closeToast?: () => void
}

const getBackgroundColor = (type: TypeOptions) => {
  switch (type) {
    case 'default':
      return 'black'

    case 'error':
      return 'red'

    case 'success':
      return 'green'

    case 'warning':
      return 'orange'

    case 'info':
      return 'blue'
  }
}

export default function Alert({ data, closeToast }: AlertProps) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px 20px',
        backgroundColor: 'white',
        border: `3px solid ${getBackgroundColor(data.type)}`,
      }}
      className='overflow-hidden rounded-md font-f37'
    >
      <p className='xs'>
        {data.type !== 'default' && (
          <span
            style={{
              color: getBackgroundColor(data.type),
              fontWeight: 'bold',
              textTransform: 'capitalize',
            }}
          >
            {data.type}:
          </span>
        )}
        <span style={{ whiteSpace: 'pre' }}>{' ' + data.text}</span>
      </p>

      <button onClick={closeToast} style={{ padding: 5 }}>
        <Icon name='MdClose' size={20} />
      </button>
    </div>
  )
}

/**
 * React toastify wrapper function
 * To specify alert `type` use addAlert methods `error | success | info | warning` or pass type into `options` object
 * @param text text to render in alert
 * @param options alert options
 */
export function addAlert(text: string, options?: ToastOptions) {
  toast(Alert, {
    ...options,
    data: {
      text: text,
      type: options?.type || 'default',
    },
  })
}

/**
 * Invokes error alert
 */
addAlert.error = (text: string, options?: ToastOptions) => {
  toast(Alert, {
    ...options,
    data: {
      text: text,
      type: 'error',
    },
  })
}

/**
 * Invokes success alert
 */
addAlert.success = (text: string, options?: ToastOptions) => {
  toast(Alert, {
    ...options,
    data: {
      text: text,
      type: 'success',
    },
  })
}

/**
 * Invokes info alert
 */
addAlert.info = (text: string, options?: ToastOptions) => {
  toast(Alert, {
    ...options,
    data: {
      text: text,
      type: 'info',
    },
  })
}

/**
 * Invokes warning alert
 */
addAlert.warning = (text: string, options?: ToastOptions) => {
  toast(Alert, {
    ...options,
    data: {
      text: text,
      type: 'warning',
    },
  })
}
